import { initialState, State, Action } from 'store/store';

export const addFeedBackData = (
  state: State = initialState,
  { data }: Action
) => {
  //
  // console.log(data.key, data);

  return {
    ...state,
    feedback: {
      ...state.feedback,
      [data.key]: data,
    },
  };
};
